import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { navigateToFlowComposerPrompt } from '@/lib/flow-composer-handoff';
import { forgeRequest } from '@/components/profile/setup/SetupAction';
import type { CompanyQualificationSheet } from '@shared/types/company-qualification';

/**
 * The applications the analysis proposes, put forward as soon as the analyst writes
 * one (not only in the plan): each opens the Forge filled with the measured need.
 */
export const AppProposals = ({ sheet }: { sheet: CompanyQualificationSheet }) => {
  const navigate = useNavigate();
  const apps = sheet.proposal.apps.filter((app) => app.decision !== 'dismissed' && !app.doneAt);
  if (apps.length === 0) return null;
  return (
    <section aria-label="Applications proposées" className="rounded-xl border border-domino-aubergine/30 bg-domino-lilac/50 px-5 py-4">
      <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-domino-aubergine">
        <Sparkles className="h-4 w-4" aria-hidden />
        {apps.length > 1 ? `${apps.length} applications à créer` : 'Une application à créer'}
      </h2>
      <div className="mt-3 grid grid-cols-[repeat(auto-fill,minmax(16rem,1fr))] gap-3">
        {apps.map((app) => (
          <div key={app.id} className="flex flex-col rounded-lg border border-domino-cardBorder bg-white/80 px-4 py-3">
            <p className="font-semibold leading-6 text-domino-ink">{app.title}</p>
            <p className="mt-1 text-sm leading-6 text-domino-ink">{app.bottleneck}</p>
            {app.cost && <p className="mt-1 text-xs leading-5 text-domino-inkSoft">Aujourd’hui : {app.cost}</p>}
            <div className="mt-auto pt-3">
              <Button size="sm" onClick={() => navigateToFlowComposerPrompt(navigate, forgeRequest(app))}>Créer dans la Forge</Button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
